<script setup>
import {
  onMounted,
  onUnmounted,
  ref,
  watch,
  computed,
  defineExpose,
  defineEmits,
} from 'vue';

import { useElementSize, useStyleTag } from '@vueuse/core';

import { useRoute, useRouter } from 'vue-router/composables';

import { customCss } from '@/views/experimental/table-view/quasar.js';

import { debounce } from 'quasar';

import Dashboard from './dashboard/Dashboard.vue';

import CreateBooking from './booking/CreateBooking.vue';
import CreateVendor from './vendors/CreateVendor.vue';
import CreateCustomer from './customer/CreateCustomer.vue';
import CreateDriver from './driver/CreateDriver.vue';

import ManageBooking from './booking/ManageBooking.vue';
import VendorList from './vendors/VendorList.vue';
import CustomerList from './customer/CustomerList.vue';
import DriverList from './driver/DriverList.vue';

import { submitForm } from './forms/currentModel';

const { id, css, load, unload } = useStyleTag(customCss, { id: 'naruto' });
onUnmounted(() => {
  unload();
});

const tabs = [
  { name: 'Booking', child: ['Create Booking', 'Manage Booking'] },
  // { name: 'Vendors', child: ['Create Vendor', 'Vendor List'] },
  { name: 'Customer', child: ['Create Customer', 'Customer List'] },
  { name: 'Driver', child: ['Create Driver', 'Driver List'] },
];
const userInfo = JSON.parse(localStorage.getItem('userInfo'));

const selected = ref('Dashboard');
const tab = computed(() => {
  const found = tabs.find((tab) => tab.child.includes(selected.value));
  return found ? found.name : selected.value;
});

// Method to handle the event from child components
function handleCreationSuccess(targetView) {
  console.log(`Received creation-success event, changing view to: ${targetView}`);
  selected.value = targetView;
}

// Method to handle view changes from list components
function handleViewChange(newView) {
  console.log(`Received update:selected event, changing view to: ${newView}`);
  selected.value = newView;
}
</script>
<template>
  <div class="bg- fit flex flex-col">
    <q-tabs v-model="tab" class="text-primary pointer-events-none" flat dense>
      <q-tab name="Dashboard" @click.prevent>
        <div
          class="flex fit items-center gap-2 px-4 pointer-events-auto"
          @click.stop="selected = 'Dashboard'"
        >
          <span>Dashboard</span>
        </div>
      </q-tab>
      <q-tab
        v-for="tab in tabs"
        :key="tab.name"
        :name="tab.name"
        @click.prevent
        class="pointer-events-none px-0"
      >
        <div
          class="flex fit items-center gap-2 px-4 pointer-events-auto"
          @click.stop
        >
          <span>{{ tab.name }}</span>
          <q-icon name="keyboard_arrow_down" />

          <q-menu>
            <q-list style="min-width: 100px" dense>
              <q-item
                clickable
                v-close-popup
                v-for="item in tab.child"
                @click="selected = item"
                :key="item"
                :active="item === selected"
                active-class="bg-primary text-white"
              >
                <q-item-section>{{ item }}</q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </div>
      </q-tab>
    </q-tabs>
    <div class="flex-1 flex overflow-auto p-4">
      <q-card class="shadow w-full">
        <Dashboard v-if="selected === 'Dashboard'" />
        <CreateBooking
          :selected="selected"
          v-if="selected === 'Create Booking'"
          @creation-success="handleCreationSuccess"
        />
        <CreateVendor
          :selected="selected"
          v-if="selected === 'Create Vendor'"
          @creation-success="handleCreationSuccess"
        />
        <CreateCustomer
          :selected="selected"
          v-if="selected === 'Create Customer'"
          @creation-success="handleCreationSuccess"
        />
        <CreateDriver
          :selected="selected"
          v-if="selected === 'Create Driver'"
          @creation-success="handleCreationSuccess"
        />

        <ManageBooking
          :selected="selected"
          v-if="selected === 'Manage Booking'"
          @update:selected="handleViewChange"
        />
        <VendorList :selected="selected" v-if="selected === 'Vendor List'" />
        <CustomerList
          :selected="selected"
          v-if="selected === 'Customer List'"
          @update:selected="handleViewChange"
        />
        <DriverList 
          :selected="selected" 
          v-if="selected === 'Driver List'"
          @update:selected="handleViewChange"
        />
      </q-card>
    </div>
  </div>
</template>

<style>
.q-item {
  padding: 8px 10px;
}
.q-field__inner {
  padding: 0px;
}
</style>
